import { render, staticRenderFns } from "./contents.vue?vue&type=template&id=3c698f79&scoped=true&"
import script from "./contents.vue?vue&type=script&lang=ts&scoped=true&"
export * from "./contents.vue?vue&type=script&lang=ts&scoped=true&"
import style0 from "./contents.vue?vue&type=style&index=0&id=3c698f79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c698f79",
  null
  
)

export default component.exports